import { IncludedProductProduct } from 'modules/product-details/types';
import Image from "next/legacy/image";
import Link from 'next/link';
import React from 'react';
import { generalImageLoader } from 'utils/image-loader';

interface PropTypes
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  product: IncludedProductProduct;
  variantId: number;
  quantity: number;
}

const BundleItem: React.FC<PropTypes> = ({
  product,
  variantId,
  quantity,
  className,
}) => {
  return (
    (<div className={className}>
      <div className="flex w-28 flex-col lg:mb-4">
        <Link
          href={`/products/${product.handle}?variant=${variantId}`}
          passHref
          className="block">

          <div className="border-grey-200 relative h-auto rounded-full border-2 p-2">
            <Image
              className="rounded-full"
              loader={generalImageLoader}
              src={`${product?.image?.src}`}
              sizes="92px"
              width="300"
              height="300"
              alt={product.title}
              layout="responsive"
            />
            <div className="absolute right-0 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary-main pt-1 text-sm text-text-dark-bg-contrast-white">
              {quantity}
            </div>
          </div>
          <div
            data-test="product.title"
            className="mt-2 w-full text-center text-xs text-text-primary"
          >
            {product.title}
          </div>

        </Link>
      </div>
    </div>)
  );
};

export default BundleItem;
